import { Box, useTheme } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { SText } from '@setvi/shared/components';
import { Product } from '@setvi/shared/interfaces';

interface ProfitProps {
  price: Product['price'];
  cost: Product['cost'];
  loading?: boolean;
}

export const Profit = ({ price, cost, loading }: ProfitProps) => {
  const { palette } = useTheme();
  if (loading) return <Skeleton />;

  if (!Number.isFinite(cost) || Number(price) <= cost || !Number(price))
    return '-';

  return (
    <Box display="flex" flexDirection="column">
      <SText
        lineHeight="24px"
        style={{ marginBottom: '3px' }}
        title={`${(price - cost).toLocaleString('en-US', {
          currency: 'USD',
          style: 'currency'
        })}`}
      />
      <SText
        size="sm"
        lineHeight="20px"
        fontColor={palette.success.main}
        title={`(${(((price - cost) / price) * 100).toFixed(2).toString()}%)`}
      />
    </Box>
  );
};
